import { ERROR_DEMAND, GET_DEMANDS, GET_DEMAND } from '../actions/types';

const initialState = {
  demand: {},
  demands: [],
  loading: true,
  error: {}
}

export default function(state = initialState, action){
  const { type, payload } = action;

  switch(type){
    case GET_DEMAND:
      return {
        ...state,
        demand: payload,
        loading: false,
        error: {}
      }
    case GET_DEMANDS:
      return {
        ...state,
        demands: payload,
        loading: false,
        error: {}
      }
    case ERROR_DEMAND:
      return {
        ...state,
        error: payload,
        loading: false
      }
    default:
      return state;
  }
}